import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authReducer, { logout } from './auth/slice'
import courseReducer from './course/slice'

const combinedReducers = combineReducers({
  auth: authReducer.reducer,
  course: courseReducer.reducer
})

const reducers = (state, action) => {
  if (action.type === [logout].toString()) {
    // reset all states
    return combinedReducers({}, action)
  }
  return combinedReducers(state, action)
}

export default configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})
